import { Component, OnInit, inject } from '@angular/core';
import { AmlService } from '../_services/aml.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Clause } from '../_models/clause';
import { ActivatedRoute, Router } from '@angular/router';
import { ProcessStatusEnum } from '../_models/proces-status.enum';
import { switchMap, tap } from 'rxjs';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { IconService } from '../_services/icon.service';
import { CommonModule } from '@angular/common';
import { SpidTaskEnum } from '../_models/spid-task.enum';
import { AmlTaskEnum } from '../_models/aml-task.enum';

@Component({
  selector: 'app-one-shot-register',
  standalone: true,
  imports: [MatButtonModule, MatIconModule, CommonModule],
  templateUrl: './one-shot-register.component.html',
  styleUrl: './one-shot-register.component.scss',
})
export class OneShotRegisterComponent implements OnInit {
  amlService = inject(AmlService);
  private sanitizer = inject(DomSanitizer);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private iconService = inject(IconService);

  contractUrl?: SafeResourceUrl;
  clauses: Clause[] = [];

  ngOnInit(): void {
    let preContrattuale = this.amlService.clausesCustomer?.find(
      (el) => el.id === 'RICHIEDI IL CERTIFICATO'
    );
    if (preContrattuale && preContrattuale.urls) {
      this.contractUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        preContrattuale.urls[0].url
      );
    }

    this.clauses =
      this.amlService.clausesCustomer?.map((el) => {
        return {
          ...el,
          text: el.text.replaceAll(
            'SERIAL_NUMBER',
            this.amlService.serialNumber as string
          ),
        };
      }) || [];
  }

  initIcons() {
    this.iconService.getIcons(['pdf']);
  }

  ngOnDestroy(): void {
    this.amlService.clausesCustomer = undefined;
  }

  valueClauses(clause: Clause[]): string {
    const modifiedClauses = clause.map((cls) => ({
      text: cls.text,
      id: cls.id,
      value: true,
    }));

    return JSON.stringify(modifiedClauses);
  }

  confirm() {
    const oneShotId = this.route.snapshot.paramMap.get('oneshotRegisterId');
    if (oneShotId) {
      const registerTask =
        this.amlService.taskRecord[AmlTaskEnum.ONESHOT_REGISTER] ||
        this.amlService.taskRecord[SpidTaskEnum.ONESHOT_REGISTER];
      this.amlService
        .completeTask<{
          status: ProcessStatusEnum.PENDING_ISSUEANDSIGN;
          documents: Clause[];
        }>(registerTask!, {
          clauses: this.valueClauses(this.clauses),
          retry: false,
        })
        .pipe(
          tap((res) => {
            if (res?.documents) {
              this.amlService.clausesCustomerSign = res.documents;
            }
          }),
          switchMap((res) => this.amlService.getActiveTask())
        )
        .subscribe((res) => {
          const path = this.amlService.getPath(res);
          this.router.navigate(path);
        });
    }
  }
}
